/** Avatar circular con iniciales o imagen (design.md §22.7). */
import { clsx } from 'clsx';

type AvatarSize = 32 | 40 | 48;

type AvatarProps = {
  name: string;
  src?: string | null;
  size?: AvatarSize;
  className?: string;
};

const sizeStyles: Record<AvatarSize, string> = {
  32: 'h-8 w-8 text-xs',
  40: 'h-10 w-10 text-sm',
  48: 'h-12 w-12 text-base',
};

/** Iniciales: primera letra del nombre y del ultimo apellido. */
function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
}

export function Avatar({ name, src, size = 40, className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={clsx('shrink-0 rounded-full object-cover', sizeStyles[size], className)}
      />
    );
  }

  return (
    <span
      role="img"
      aria-label={name}
      className={clsx(
        'flex shrink-0 items-center justify-center rounded-full bg-primary-light font-semibold text-primary',
        sizeStyles[size],
        className,
      )}
    >
      {initialsFor(name)}
    </span>
  );
}
